import { Button, Chip } from "@mui/material";
import CustomTable from "global/components/CustomTable/CustomTable";
import viewpaths from "global/constants/ViewPathConstants";
import { convertESTtoUserLocalTime, handleErrorMessage } from "helpers/methods";
import { useEffect, useState } from "react";
import { fetchChildCampaign } from "screens/Campaigns/CampaignService";
import { getStatusColor } from "screens/Campaigns/Components/EmailDataList";
import { SubmitCampaign } from "types/Campaign";
import history from "utils/history";

interface CustomProps {
  id: number;
  maxRows?: number;
}

const columns = [
  {
    name: "Campaign name",
    field: "campaignName",
  },
  {
    name: "Sent On",
    field: "scheduledOn",
  },
  {
    name: "Campaign status",
    field: "status",
  },
  {
    name: "",
    field: "action",
  },
];

const RetargetedCampaigns = (props: CustomProps) => {
  const [campaigns, setCampaigns] = useState([]);
  const [loading, setLoading] = useState<boolean>(false);

  useEffect(() => {
    if (props.id) {
      getChildCampaigns();
    }
  }, [props.id]);

  const convertDataToTableFormat = (data: any) => {
    return data.map((item: SubmitCampaign) => ({
      campaignName: item.campaign.name,
      scheduledOn: convertESTtoUserLocalTime(
        item.campaign.scheduleTime,
        "YYYY-MM-DDTHH:mm:ss"
      ),
      status: (
        <Chip
          label={item.campaign.status}
          sx={{
            color: getStatusColor(item.campaign.status!),
            borderRadius: "5px",
            minWidth: "90px",
          }}
        />
      ),
      action: (
        <Button
          size="small"
          variant="text"
          onClick={() =>
              history.push(
                `${viewpaths.CampaignStatsViewPath}?id=${item.campaign.id}`
              )
            }
          disabled={
            item.campaign.parentId !== null &&
            item.campaign.status === "Submitted"
          }
        >
          View Report
        </Button>
      ),
    }));
  };

  const getChildCampaigns = async () => {
    try {
      setLoading(true);
      const response = await fetchChildCampaign(props?.id);
      let tableData = convertDataToTableFormat(response);
      if (props.maxRows) {
        tableData = tableData.slice(0, props.maxRows);
      }
      setCampaigns(tableData);
      setLoading(false);
    } catch (error: any) {
      setLoading(false);
      handleErrorMessage(error);
    }
  };

  return (
    <CustomTable
      isLoading={loading}
      headers={columns}
      rows={campaigns}
      showPagination={false}
    />
  );
};

export default RetargetedCampaigns;
